import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import testTargetSelector from 'selectors/testTarget/testTargetSelector';

/**
 * Adobe Mbox ready offers selector( A/B test )
 * ref: https://confluence.sephora.com/wiki/pages/viewpage.action?pageId=453083927
 */
const testTargetReadyOffersSelector = createSelector(testTargetSelector, testTarget =>
    testTarget.readyState === 2 ? testTarget.offers || Empty.Object : Empty.Object
);

export { testTargetReadyOffersSelector };
